import { Box, Grid, Hidden, Typography } from "@material-ui/core";
import useAdditionalPurchase, {
  PURCHASE_TYPE_OPTIONS,
} from "./useAdditionalPurchase";
import { Formik } from "formik";
import FormAutoComplete, {
  FormSelect,
} from "../../../../forms/formik/FormSelectField";
import FormRadioButton, {
  FormRadio,
} from "../../../../forms/formik/FormRadioField";
import { NEW, YES } from "../../../../../store/types";

import FormTextInput from "../../../../forms/formik/FormTextInput";
import SubmitButton from "../../../../forms/formik/FormSubmitButton";
import CustomButton from "../../../../forms/CustomButton";
import InvestorDetailsPreview from "../../InvestorDetails";
import { convertToInr } from "../../../../../utils/cart";
import FormCheckbox from "../../../../forms/formik/FormCheckbox";
import { Fragment } from "react";

export default function AdditionalPurchase() {
  const {
    changeHandlers,
    goToCart,
    initialValues,
    onSubmit,
    options,
    isEdit,
    payload,
    validationSchema,
  } = useAdditionalPurchase();

  const {
    handleCategoryChange,
    handleFolioChange,
    handleSchemeChange,
    handleTypeChange,
    handleComboSwitch,
  } = changeHandlers;

  const { categoryOptions, folioOptions, fundOptions, schemeOptions } = options;

  return (
    <Grid container>
      <Grid item lg={9} sm={12}>
        <Box
          sx={{
            margin: "40px",
            marginRight: "10px",
            bgcolor: "white",
            padding: "18px 24px 18px 24px",
            boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
            borderRadius: "4px",
          }}
        >
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            validateOnBlur
            enableReinitialize
          >
            {function ({ values, setValues, handleSubmit }) {
              return (
                <Box component="form" onSubmit={handleSubmit}>
                  <Typography
                    component="h4"
                    style={{
                      fontWeight: "800",
                      fontSize: "24px",
                      marginBottom: "20px",
                      fontFamily: "OpenSans-SemiBold",
                    }}
                  >
                    Additional Purchase
                  </Typography>

                  <FormAutoComplete
                    name="amc"
                    label={"AMC"}
                    options={fundOptions}
                    disabled
                  />
                  <FormSelect
                    name="folio"
                    label="Folio"
                    disabled={!values.amc}
                    options={folioOptions}
                    onChange={handleFolioChange(values, setValues)}
                  />
                  <FormRadioButton
                    label="Scheme Type"
                    name="purchaseType"
                    options={PURCHASE_TYPE_OPTIONS}
                    onChange={handleTypeChange(values, setValues)}
                  />
                  {values.purchaseType === NEW ? (
                    <FormAutoComplete
                      name="category"
                      label="Category"
                      options={categoryOptions}
                      onChange={handleCategoryChange(values, setValues)}
                    />
                  ) : null}
                  <FormAutoComplete
                    name="scheme"
                    label="Scheme"
                    options={schemeOptions}
                    onChange={handleSchemeChange(values, setValues)}
                  />
                  {(() => {
                    // @ts-ignore
                    const selectedScheme: any = schemeOptions.find(
                      (scheme: any) => scheme.value === values.scheme
                    );

                    return (
                      selectedScheme &&
                      selectedScheme.combo_flag === YES && (
                        <Fragment>
                          <FormCheckbox
                            label="Purchase Cum Switch"
                            name="combo"
                            onChange={handleComboSwitch(values, setValues)}
                          />
                          <div
                            style={{
                              color: "#283d7c",
                              fontSize: 14,
                              fontFamily: "OpenSans-SemiBold",
                              margin: 10,
                            }}
                          >
                            {selectedScheme.combo_disclaimer}
                          </div>
                        </Fragment>
                      )
                    );
                  })()}

                  <FormTextInput
                    name="amount"
                    label={
                      values.minAmount
                        ? `Investment Amount (Minimum ${convertToInr(
                            values.minAmount
                          )})`
                        : "Investment Amount"
                    }
                    type="number"
                  />
                  <Box display="flex">
                    <CustomButton
                      label="Go To Cart"
                      variant="outlined"
                      onClick={goToCart}
                    />
                    <SubmitButton
                      label={isEdit ? "Update" : "Add To Cart"}
                      variant="contained"
                    />
                  </Box>
                </Box>
              );
            }}
          </Formik>
        </Box>
      </Grid>
      <Hidden mdDown>
        <Grid item lg={3}>
          <InvestorDetailsPreview
            investorData={[
              { label: "Investor Name", value: payload.investorName },
              { label: "PAN", value: payload.pan },
              { label: "Email", value: payload.email },
              { label: "Mobile", value: payload.mobile },
              {
                label: "EUIN",
                value: payload.euin ? "Yes" : "No",
              },
              { label: "EUIN", value: payload.euin || "-" },
              { label: "Sub ARN Code", value: payload.subArn || "-" },
              { label: "Sub Broker Code", value: payload.subBroker || "-" },
            ]}
          />
        </Grid>
      </Hidden>
    </Grid>
  );
}
